/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { UtteranceIntent } from 'src/luis/projects/utterances/types/Utterance';

/**
 * Returns the top scoring intent from the given
 * predicted intents.
 *
 * @param intents The intent predictions.
 * @returns The top scoring intent.
 */
export const getTopScoringIntent = (intents: UtteranceIntent[]): UtteranceIntent => intents.reduce((p, v) => (p.score > v.score ? p : v));
